import { useRef, useCallback } from 'react';

function useGameSounds() {
    const ctxRef = useRef(null);

    const getCtx = () => {
        if (!ctxRef.current || ctxRef.current.state === 'closed') {
            ctxRef.current = new (window.AudioContext || window.webkitAudioContext)();
        }
        if (ctxRef.current.state === 'suspended') {
            ctxRef.current.resume();
        }
        return ctxRef.current;
    };

    const playTone = (freq, duration, type = 'sine', gain = 0.3, delay = 0) => {
        const ctx = getCtx();
        const osc = ctx.createOscillator();
        const vol = ctx.createGain();
        osc.type = type;
        osc.frequency.value = freq;
        vol.gain.setValueAtTime(gain, ctx.currentTime + delay);
        vol.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + delay + duration);
        osc.connect(vol);
        vol.connect(ctx.destination);
        osc.start(ctx.currentTime + delay);
        osc.stop(ctx.currentTime + delay + duration);
    };

    const playWin = useCallback(() => {
        // Ascending triumphant arpeggio
        playTone(523, 0.15, 'square', 0.2, 0);      // C5
        playTone(659, 0.15, 'square', 0.2, 0.12);    // E5
        playTone(784, 0.15, 'square', 0.2, 0.24);    // G5
        playTone(1047, 0.35, 'square', 0.25, 0.36);  // C6 (hold)
        // Shimmering high note
        playTone(1568, 0.4, 'sine', 0.1, 0.4);       // G6 sparkle
    }, []); // eslint-disable-line

    const playLose = useCallback(() => {
        // Descending minor tones
        playTone(440, 0.25, 'sawtooth', 0.15, 0);    // A4
        playTone(370, 0.25, 'sawtooth', 0.15, 0.2);  // F#4
        playTone(311, 0.4, 'sawtooth', 0.12, 0.4);   // Eb4
        // Low rumble
        playTone(110, 0.5, 'sine', 0.15, 0.5);       // A2
    }, []); // eslint-disable-line

    const playDraw = useCallback(() => {
        // Neutral two-tone
        playTone(440, 0.2, 'triangle', 0.2, 0);      // A4
        playTone(440, 0.3, 'triangle', 0.15, 0.25);   // A4 repeat
    }, []); // eslint-disable-line

    const playChoose = useCallback(() => {
        // Quick click/confirm
        playTone(880, 0.08, 'square', 0.15, 0);
        playTone(1100, 0.1, 'square', 0.1, 0.06);
    }, []); // eslint-disable-line

    return { playWin, playLose, playDraw, playChoose };
}

export default useGameSounds;
